import React from 'react';
import { APP_EVENTS, logHubxEvent } from '@/app/providers/analytics';
import { NextUI } from '@/components/NextUI';
import ProcessingSpinner from '@/components/Common/Icons/ProcessingSpinner';

interface FallbackProgressModalData {
  title?: string;
  description?: string;
  source: string;
  onCancel?: () => void;
}

const FallbackProgressModal = ({
  data,
  hideModal,
}: {
  data?: FallbackProgressModalData;
  hideModal: () => void;
}) => {
  const hasCancelledRef = React.useRef(false);

  const handleCancel = () => {
    if (hasCancelledRef.current) return;
    hasCancelledRef.current = true;

    logHubxEvent({
      eventName: APP_EVENTS.PROGRESSION_CANCEL,
      event_params: { source: data?.source },
    });
    data?.onCancel?.();
    hideModal();
  };

  return (
    <NextUI.Modal
      className="max-w-[470px]"
      classNames={{ content: 'rounded-[16px] px-12 py-8 shadow-none' }}
      defaultOpen={true}
      name="FallbackProgress"
      backdrop="blur"
      hideCloseButton={true}
      isDismissable={false}
      isKeyboardDismissDisabled={true}
    >
      <div className="flex flex-col items-center gap-8 text-center">
        <span className="block size-[52px] animate-spin text-primary-blue">
          <ProcessingSpinner className="ml-[9.71%] block h-full w-[90.29%]" />
        </span>

        <div className="flex w-full flex-col items-center gap-1">
          <p className="font-barlow text-[20px] font-semibold leading-[normal] text-[#454655]">
            {data?.title ?? 'Processing...'}
          </p>
          <p className="font-barlow text-[17px] leading-[normal] text-[#787887]">
            {data?.description ?? 'Please wait while we process your document.'}
          </p>
        </div>

        <button
          type="button"
          onClick={handleCancel}
          className="flex h-[38px] w-[79px] items-center justify-center rounded-[5px] bg-[rgba(120,120,135,0.1)] font-barlow text-[17px] font-medium leading-[normal] text-[#454655] transition-opacity hover:opacity-80"
        >
          Cancel
        </button>
      </div>
    </NextUI.Modal>
  );
};

export default FallbackProgressModal;
